import { z } from 'zod';
import { AspectRatioSchema } from './aspect-ratio';

export const TemplateSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  description: z.string(),
  aspectRatio: AspectRatioSchema,
  needsProductImages: z.boolean(),
  promptTemplate: z.string(),
});
export type Template = z.infer<typeof TemplateSchema>;

export const ResolvedPromptSchema = z.object({
  templateId: z.number().int().positive(),
  templateName: z.string(),
  aspectRatio: AspectRatioSchema,
  needsProductImages: z.boolean(),
  numImages: z.number().int().min(1).max(10),
  prompt: z.string().min(10),
});
export type ResolvedPrompt = z.infer<typeof ResolvedPromptSchema>;
